import { render, staticRenderFns } from "./SiblingLevelCardItem.vue?vue&type=template&id=c2ceddd6&scoped=true&"
import script from "./SiblingLevelCardItem.vue?vue&type=script&lang=js&"
export * from "./SiblingLevelCardItem.vue?vue&type=script&lang=js&"
import style0 from "./SiblingLevelCardItem.vue?vue&type=style&index=0&id=c2ceddd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ceddd6",
  null
  
)

export default component.exports